import * as React from 'react';
import { styles } from './styles';

import { MonthToggler, Props as MonthTogglerProps } from './components/MonthToggler/index';
import { Calendar, Props as CalendarProps } from './components/Calendar/index';

type Props = {
  handleDateSelection: CalendarProps['handleClick'];
  currentSelectionMoment: CalendarProps['currentSelectionMoment'];
} & MonthTogglerProps;

const DateSelector: React.SFC<Props> = ({
  handleMonthClick,
  handleTodayClick,
  handleDateSelection,
  currentSelectionMoment
}) => {
  return (
    <div className={styles.containerRules}>
      <MonthToggler handleMonthClick={handleMonthClick} handleTodayClick={handleTodayClick} />
      <Calendar handleClick={handleDateSelection} currentSelectionMoment={currentSelectionMoment} />
    </div>
  );
};

export { DateSelector };
